<form [ngClass]="isDialog ? ['px-5', 'py-5', 'text-center'] : ['cargo__generate_filter--inline']" class="row relative" *ngIf="reactiveForm"
  [formGroup]="reactiveForm.form" (submit)="onSubmit()">
  <i *ngIf="dialogParams && dialogParams.type" matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions"
    (click)="dialogRef.close()"></i>
  <p *ngIf="dialogParams?.title" class="col-12 title">
    {{ dialogParams.title }}
  </p>
  <div class="col-12 d-flex justify-content-center mb-3" *ngIf="isDialog && transportCompanyId">
    <app-transport-company-context [initialNit]="transportCompanyId" [readonly]="true"></app-transport-company-context>
  </div>
  <!-- Pestaña Egresos: los archivos se generan para la empresa de transporte elegida. -->
  <div class="col-md-3 cargo__generate_filter--transport-company" *ngIf="!isDialog">
    <app-transport-company-context [initialNit]="initialTransportCompanyId" size="field"
      (companyChange)="onTransportCompanyChange($event)">
    </app-transport-company-context>
  </div>

  <div [ngClass]="{'col-12': isDialog, 'col-md-3': !isDialog}">
    <mat-form-field class="cargo__generate_filter--field" appearance="outline">
      <mat-label>Tipo Archivo</mat-label>
      <mat-select formControlName="typeFile">
        <mat-option value="{{type.id}}" *ngFor="let type of typeFiles;">
          {{type.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="col-md-12 mb-3 d-flex justify-content-between align-items-center flex-wrap" *ngIf="isDialog">
    <label class="text-strong mr-3 text-left">
      ¿Incluir servicios sin pago (contabilizar todo el período)?
      <i matSuffix class="fas fa-info-circle color-secondary-dark cursor-pointer"
        matTooltip="Si se activa, también se generarán comprobantes contables para los servicios que no tienen pagos registrados durante el mes seleccionado."
        matTooltipClass="tooltip__alert" matTooltipPosition="right"></i>
    </label>
    <mat-button-toggle-group #group="matButtonToggleGroup" formControlName="includeWithoutPayments"
      (change)="onChangeIncludeWithoutPayments($event)">
      <mat-button-toggle [value]="true">
        Si
      </mat-button-toggle>
      <mat-button-toggle [value]="false">
        No
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <mat-form-field class="col-md-12 mb-3 cargo__generate_filter--field" appearance="outline"
    *ngIf="isDialog && reactiveForm.form.get('includeWithoutPayments').value">
    <mat-label class="text-strong mr-3">Mes</mat-label>
    <mat-select [formControl]="monthSelected" (selectionChange)="onChangeMonthSelected($event)">
      <mat-option [value]="month" *ngFor="let month of monthsOptions;">
        {{month.label}}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="monthSelected.errors?.required">
      {{ utils.giveMessageError('MANDATORY_FIELD') }}
    </mat-error>
  </mat-form-field>

  <div [ngClass]="{'col-12': isDialog, 'col-md-3': !isDialog}"
    *ngIf="!reactiveForm.form.get('includeWithoutPayments').value">
    <mat-form-field class="cargo__generate_filter--field cursor-pointer" appearance="outline"
      (click)="pickerDateFrom.open()">
      <mat-label>Desde</mat-label>
      <input class="cursor-pointer" (click)="pickerDateFrom.open()" matInput [min]="optionsDateFrom.minDate"
        [max]="reactiveForm.form.get('dateUntil')?.value ? reactiveForm.form.get('dateUntil')?.value : optionsDateFrom.maxDate" [matDatepicker]="pickerDateFrom"
        formControlName="dateFrom" readonly>
      <mat-datepicker-toggle matSuffix [for]="pickerDateFrom"></mat-datepicker-toggle>
      <mat-datepicker #pickerDateFrom></mat-datepicker>
      <mat-error *ngIf="reactiveForm.form.get('dateFrom').errors?.required">
        {{ utils.giveMessageError('MANDATORY_FIELD') }}
      </mat-error>
    </mat-form-field>
  </div>
  <div [ngClass]="{'col-12': isDialog, 'col-md-3': !isDialog}"
    *ngIf="!reactiveForm.form.get('includeWithoutPayments').value">
    <mat-form-field class="cargo__generate_filter--field cursor-pointer" appearance="outline"
      (click)="pickerDateUntil.open()">
      <mat-label>Hasta</mat-label>
      <input class="cursor-pointer" (click)="pickerDateUntil.open()" matInput
        [min]="reactiveForm.form.get('dateFrom')?.value ? reactiveForm.form.get('dateFrom')?.value : null" [max]="optionsDateUntil.maxDate"
        [matDatepicker]="pickerDateUntil" formControlName="dateUntil" readonly>
      <mat-datepicker-toggle matSuffix [for]="pickerDateUntil"></mat-datepicker-toggle>
      <mat-datepicker #pickerDateUntil></mat-datepicker>
      <mat-error *ngIf="reactiveForm.form.get('dateUntil').errors?.required">
        {{ utils.giveMessageError('MANDATORY_FIELD') }}
      </mat-error>
    </mat-form-field>
  </div>
  <div [ngClass]="{'col-12': isDialog, 'col-md-2': !isDialog}"
    class="button-container">
    <button mat-raised-button color="primary" class="bg-color-primary" type="submit" title="Generar">
      Generar
    </button>
  </div>
</form>
